var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1121_7572)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7765 31.3473L14.6957 31.4224C14.1799 31.9988 13.5524 32.4645 12.8514 32.7912C12.1503 33.1179 11.3902 33.2988 10.6171 33.3231C7.5899 33.3231 5.38883 31.0469 5.38883 27.91C5.38883 24.773 7.5899 22.5027 10.6171 22.5027C11.3902 22.5269 12.1503 22.7079 12.8514 23.0346C13.5524 23.3613 14.1799 23.8269 14.6957 24.4033L14.7765 24.4842L16.7234 22.1214L16.6714 22.0636C15.9653 21.1619 15.0603 20.4357 14.0271 19.9416C12.9939 19.4476 11.8604 19.1991 10.7153 19.2155C8.44502 19.1659 6.23962 19.9746 4.53961 21.4801C2.85895 23.1996 1.91797 25.5085 1.91797 27.9129C1.91797 30.3173 2.85895 32.6262 4.53961 34.3456C6.23812 35.8536 8.44454 36.6627 10.7153 36.6102C11.8598 36.6265 12.9927 36.3785 14.0257 35.8855C15.0587 35.3925 15.9641 34.6679 16.6714 33.7679L16.7234 33.7044L14.7765 31.3473Z",
    fill: "#004785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1365 19.4707H18.6934V36.2761H22.1365V19.4707Z",
    fill: "#004785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.62 32.6129C34.8667 33.123 33.987 33.415 33.0781 33.4564C31.9632 33.4564 31.4663 32.8786 31.4663 31.5615V22.6475H34.973V19.4817H31.4663V14.2534L28.0868 16.0559V19.4817H25.1982V22.6475H28.0868V32.1334C28.0868 34.7157 29.6177 36.4777 31.9054 36.524C32.9781 36.5798 34.0427 36.3121 34.9614 35.7556H34.9961L35.8511 32.5031L35.62 32.6129Z",
    fill: "#004785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9118 19.4707H38.4688V36.2761H41.9118V19.4707Z",
    fill: "#004785"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.9389 16.5188C42.3979 14.3222 40.3504 12.529 37.9697 11.291C35.589 10.0531 32.9451 9.40674 30.2618 9.40674C27.5784 9.40674 24.9346 10.0531 22.5539 11.291C20.1732 12.529 18.1257 14.3222 16.5846 16.5188L16.4229 16.7441H20.3801L20.4263 16.6979C21.6888 15.3554 23.2127 14.2856 24.9042 13.5543C26.5957 12.823 28.419 12.4458 30.2618 12.4458C32.1046 12.4458 33.9279 12.823 35.6194 13.5543C37.3109 14.2856 38.8348 15.3554 40.0972 16.6979L40.1434 16.7441H44.1007L43.9389 16.5188Z",
    fill: "#ED1C2E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1121_7572"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.1667,
    height: 27.1868,
    fill: "white",
    transform: "translate(1.91699 9.40674)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg46);
export default __webpack_public_path__ + "static/media/씨티-46.cd7838a9d41823078387baa97ef87ba9.svg";
export { ForwardRef as ReactComponent };